import { includes } from 'ramda'
import { memo } from 'react'
import styled from 'styled-components'
import BubbleMessage from './bubble-message'
import SystemMessage from './system-message'

const MessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

const systemMessages = [
  'chat_new_user',
  'chat_remove_user',
  'chat_timeline_locked',
  'chat_timeline_deleted',
  'phantom_message',
  'chat_listing_match',
  'chat_welcome_message',
  'chat_copy_application_from',
  'chat_copy_application_to',
  'chat_welcome_support',
  'chat_end_contract_ended',
  'chat_end_contract_notice1',
  'chat_end_contract_notice2'
]

const Message = ({
  avatar,
  className,
  event,
  isGroupChat,
  position,
  showName,
  isFirst,
  showUserName,
  previousMessage,
  isLastMessageOfUser,
  nextMessage,
  isSupportRoom,
  isRead,
  history,
  userData,
  colour,
  isLocked,
  showDrawer = () => {},
  ...rest
}) => {
  const isThem = position === 'left'
  const isSystemMessage = includes(event?.event_type, systemMessages)
  const parsedUserData = {
    name: userData?.preferred_name,
    phoneNumber: userData?.phone_number,
    email: userData?.username,
    isVerified: userData?.identity_verified_state,
    companyName: userData?.company?.name || null,
    avatar: userData?.avatar,
    id: event.user_id,
    isLocked
  }

  return (
    <MessageContainer
      className="chat-event-message"
      isFirst={isFirst}
      id={`chat-event-message-${event.id}`}
      data-testid={`message-${event.event_type}-${event.id}`}
    >
      {isSystemMessage ? (
        <SystemMessage isThem={isThem} event={event} />
      ) : (
        <BubbleMessage
          userData={parsedUserData}
          isLastMessageOfUser={isLastMessageOfUser}
          showUserName={isThem && showUserName}
          isSupportRoom={isSupportRoom}
          isGroupChat={isGroupChat}
          avatar={avatar}
          showDrawer={showDrawer}
          history={history}
          isRead={isRead}
          showName={showName}
          isThem={isThem}
          event={event}
          previousMessage={previousMessage}
          nextMessage={nextMessage}
          colour={colour}
        />
      )}
    </MessageContainer>
  )
}

export default memo(Message)
